function apply(el, binding) {
  if (typeof binding.value === "object") {
    jQuery(el).inputmask(binding.value);
  } else {
    jQuery(el).inputmask(binding.value, {
      placeholder: " ",
      keepStatic: true,
    });
  }
}

export default {
  bind(el, binding) {
    if (!binding.value) {
      return;
    }
    apply(el, binding);
  },
  update(el, binding) {
    if (
      JSON.stringify(binding.oldValue) === JSON.stringify(binding.value)
    ) {
      return;
    }
    jQuery(el).inputmask("remove");
    if (!binding.value) {
      return;
    }
    apply(el, binding);
  },
  unbind(el) {
    jQuery(el).inputmask("remove");
  },
};
